import TrackerDataTableItemAssociations
from '@/applications/scrum/components/TrackerDataTable/TrackerDataTableItemAssociations/TrackerDataTableItemAssociations'
import RenderMixinMobile from '@/agilis/mobile/ListCardMobileMixins/renderMixinMobile'
import Configuration from '@/agilis/util/Configuration'
import L from 'lodash'

export default {
  name: 'TrackerDataTableItemAssociationsMobile',
  mixins: [TrackerDataTableItemAssociations, RenderMixinMobile],
  methods: {
    handleAssociatedClick (associationTracker) {
      if (associationTracker && associationTracker.trackerTypeId === 'opportunity') {
        console.log(associationTracker)
        this.$router.agilis.viewTracker({
          applicationId: associationTracker.applicationId,
          trackerId: associationTracker.id,
          trackerTypeId: associationTracker.trackerTypeId,
          parentTrackerId: this.trackerId,
          workspaceId: associationTracker.workspaceId
        })
      }
    }
  },
  computed: {
    itemLayout () {
      return Configuration.datatable.getDatatable(
        {
          applicationId: this.applicationId,
          trackerTypeId: this.trackerTypeId,
          workspaceId: this.workspaceId }).mobile?.associationItemLayout
    },
    dataTableConfiguration () {
      let configuration = L.cloneDeep(Configuration.simpleTable.getAssociationsTable(this.applicationId, this.trackerTypeId))
      configuration.columns = configuration.columns.reduce((acc, current) => {
        acc[current.id] = current
        return acc
      }, {})
      return configuration
    }
  }
}
